import React, { Fragment } from 'react';
import Intro from '../Intro';
import MultipleChoice from '../MultipleChoice';
import mainConfidenceImage from '../../assets/images/confidence-ranking.gif';
import stronglyAgree from '../../assets/images/confidence-strongly-agree.svg';
import agree from '../../assets/images/confidence-agree.svg';
import neutral from '../../assets/images/confidence-neutral.svg';
import disagree from '../../assets/images/confidence-disagree.svg';
import stronglyDisagree from '../../assets/images/confidence-strongly-disagree.svg';
import Voiceover from '../Voiceover';

const data = {
  inputType: 'radio',
  options: [
    {
      label: 'Totalmente de acuerdo',
      image: stronglyAgree
    },
    {
      label: 'De acuerdo',
      image: agree
    },
    {
      label: 'Neutral',
      image: neutral
    },
    {
      label: 'En desacuerdo',
      image: disagree
    },
    {
      label: 'Totalmente en desacuerdo',
      image: stronglyDisagree
    }
  ]
};

const standardReflectFeedback = {
  success: {
    title: 'Okay.',
    body: 'Gracias por tu respuesta. Ahora veamos lo que has aprendido.'
  }
};

const standardPrepareFeedback = {
  success: {
    title: 'Gracias.',
    body: 'Aprenderás más sobre este tema al ir avanzando en el módulo.'
  }
};

export const ConfidenceRankingSpanish = ({
  direction,
  lead,
  image,
  feedback,
  question,
  title,
  vo
}) => {
  const reflect = window.location.href.indexOf('reflect') > 0;
  const determineFeedback = () => {
    if (feedback) return feedback;
    return reflect ? standardReflectFeedback : standardPrepareFeedback;
  };

  return (
    <Fragment>
      {vo && <Voiceover {...vo} />}
      <Intro
        title={title ? title : '¿Tú qué piensas?'}
        lead={
          lead
            ? lead
            : 'Selecciona la imagen que mejor describa en qué medida estás de acuerdo o en desacuerdo con el enunciado.'
        }
        direction={direction ? direction : 'Selecciona la mejor respuesta.'}
        img={image ? image : mainConfidenceImage}
      />
      <MultipleChoice
        data={{
          ...data,
          question
        }}
        feedback={determineFeedback()}
      />
    </Fragment>
  );
};



// WEBPACK FOOTER //
// ../core/src/components/ConfidenceRanking/ConfidenceRankingSpanish.js